import { render, staticRenderFns } from "./UserPromotions.vue?vue&type=template&id=3188685f&scoped=true"
import script from "./UserPromotions.vue?vue&type=script&lang=js"
export * from "./UserPromotions.vue?vue&type=script&lang=js"
import style0 from "./UserPromotions.vue?vue&type=style&index=0&id=3188685f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188685f",
  null
  
)

export default component.exports